import React, { useEffect, useState } from "react";
import { Outlet, useLocation, useOutletContext, useParams } from "react-router";
import BoxLayout from "../../../components/Common/BoxLayout/BoxLayout";
import { createSeries } from "../../../utils/mainTabs/distribute/createSeries";
import classes from "./CreateSeries.module.scss";
import { useDispatch } from "react-redux";
import { getClassAndCollectionByProgramIdActionHandler } from "../../../store/actions/actionHandlers/organizeActionHandler";
import {
  setCertificateByProgramIdAction,
  setClassAndCollectionByProgramIdAction,
} from "../../../store/actions/actionCreators/distributeActionCreator";
import { getCertificateByProgramIdActionHandler } from "../../../store/actions/actionHandlers/distributeActionHandler";

const CreateSeries = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const location = useLocation();
  const { tenantName, distributeTiles, setDistributeTiles } =
    useOutletContext();
  const notificationSettingsPath =
    createSeries.notificationSettings.path(tenantName);
  const certificateSettingsPath =
    createSeries.certificateSettings.path(tenantName);
  const distributionDetailsPath =
    createSeries.distributionDetails.path(tenantName);
  const [heading, setHeading] = useState("");
  const [formValues, setFormValues] = useState({
    NoDaysToNotifyBeforeDueDate: 1,
    CanDisplayClassPostDuedate: false,
    DueDate: "",
    ImageUrl: null,
    IsSelfPacedProgram: true,
    IsSpreadProgram: false,
    Name: "",
    Tags: [],
  });

  useEffect(() => {
    if (
      location?.pathname === notificationSettingsPath ||
      location?.pathname ===
        `${createSeries.copyPath(tenantName)}/${
          params?.programId
        }/notificationDetails` ||
      location?.pathname ===
        `${createSeries.editPath(tenantName)}/${
          params?.programId
        }/notificationDetails`
    ) {
      setHeading(createSeries.notificationSettings.name);
    } else if (
      location?.pathname === certificateSettingsPath ||
      location?.pathname ===
        `${createSeries.copyPath(tenantName)}/${
          params?.programId
        }/certificateSettings` ||
      location?.pathname ===
        `${createSeries.editPath(tenantName)}/${
          params?.programId
        }/certificateSettings`
    ) {
      setHeading(createSeries.certificateSettings.name);
    } else if (
      location?.pathname === distributionDetailsPath ||
      location?.pathname ===
        `${createSeries.copyPath(tenantName)}/${
          params?.programId
        }/seriesDetails` ||
      location?.pathname ===
        `${createSeries.editPath(tenantName)}/${
          params?.programId
        }/seriesDetails`
    ) {
      setHeading(createSeries.distributionDetails.name);
    }
  }, [
    location,
    notificationSettingsPath,
    certificateSettingsPath,
    distributionDetailsPath,
    params,
    tenantName,
  ]);

  useEffect(() => {
    if (
      (location?.pathname ===
        `${createSeries.copyPath(tenantName)}/${params?.programId}` ||
        location?.pathname ===
          `${createSeries.editPath(tenantName)}/${params?.programId}`) &&
      params?.programId
    ) {
      dispatch(
        getClassAndCollectionByProgramIdActionHandler(
          params?.programId,
          "en-GB"
        )
      ).then((res) => {
        if (res?.status === 200 && res?.data) {
          dispatch(setClassAndCollectionByProgramIdAction(res?.data));
        }
      });
      dispatch(getCertificateByProgramIdActionHandler(params?.programId));
    }
  }, [location, params, tenantName, dispatch]);

  useEffect(() => {
    return () => {
      dispatch(setClassAndCollectionByProgramIdAction([]));
      dispatch(setCertificateByProgramIdAction(null));
    };
  }, [dispatch]);

  useEffect(() => {
    if (
      location?.pathname ===
        `${createSeries.path(tenantName)}/notificationSettings` ||
      location?.pathname === `${createSeries.path(tenantName)}/seriesDetails` ||
      location?.pathname ===
        `${createSeries.path(tenantName)}/certificateSettings` ||
      location?.pathname.includes(
        `${createSeries.editPath(tenantName)}/${params?.programId}`
      ) ||
      location?.pathname.includes(
        `${createSeries.copyPath(tenantName)}/${params?.programId}`
      )
    ) {
      let tiles = createSeries.tiles(tenantName, location, params);
      let updatedTiles = tiles.map((tile) => {
        if (
          (tile.path ===
            `${createSeries.path(tenantName)}/notificationSettings` ||
            tile.path.includes(
              `${createSeries.editPath(tenantName)}/${params?.programId}`
            ) ||
            tile.path.includes(
              `${createSeries.copyPath(tenantName)}/${params?.programId}`
            )) &&
          formValues?.NoDaysToNotifyBeforeDueDate
        ) {
          if (
            tile.path ===
              `${createSeries.path(tenantName)}/notificationSettings` ||
            tile.path.includes(
              `${createSeries.editPath(tenantName)}/${params?.programId}`
            ) ||
            tile.path.includes(
              `${createSeries.copyPath(tenantName)}/${params?.programId}`
            )
          )
            return { ...tile, isCompleted: true };
          else return tile;
        } else if (
          (tile.path === `${createSeries.path(tenantName)}/seriesDetails` ||
            tile.path.includes(
              `${createSeries.editPath(tenantName)}/${params?.programId}`
            ) ||
            tile.path.includes(
              `${createSeries.copyPath(tenantName)}/${params?.programId}`
            )) &&
          formValues?.Name &&
          formValues?.Tags &&
          ((formValues?.CanDisplayClassPostDuedate && !formValues?.DueDate) ||
            (!formValues?.CanDisplayClassPostDuedate && formValues?.DueDate)) &&
          formValues?.ImageUrl
        ) {
          if (
            tile.path === `${createSeries.path(tenantName)}/seriesDetails` ||
            tile.path.includes(
              `${createSeries.editPath(tenantName)}/${params?.programId}`
            ) ||
            tile.path.includes(
              `${createSeries.copyPath(tenantName)}/${params?.programId}`
            )
          )
            return { ...tile, isCompleted: true };
          else return tile;
        } else {
          return tile;
        }
      });
      setDistributeTiles(updatedTiles);
    }
  }, [location, formValues, setDistributeTiles, tenantName, params]);

  return (
    <BoxLayout>
      <div className={classes.create_series}>
        <div className={classes.heading}>{heading}</div>
        <Outlet
          context={{
            tenantName,
            formValues,
            setFormValues,
            distributeTiles,
            setDistributeTiles,
          }}
        />
      </div>
    </BoxLayout>
  );
};

export default CreateSeries;
